export class MotivoSolicitacaoModel {
    nomeIntegracao: string;
    descricao: string;

    constructor(nomeIntegracao: string, descricao: string) {
        this.nomeIntegracao = nomeIntegracao;
        this.descricao = descricao;
    }
}

export const motivosList: MotivoSolicitacaoModel[] = [
	new MotivoSolicitacaoModel("CHAVE_PORTA", "Chave trancou na porta do motorista"),
	new MotivoSolicitacaoModel("CHAVE_IGNICAO", "Chave trancou na ignição"),
	new MotivoSolicitacaoModel("CHAVE_VEICULO", "Chave dentro do veículo fechado"),
	new MotivoSolicitacaoModel("CHAVE_PORTA_MALAS", "Chave trancou dentro do porta-malas"),
	new MotivoSolicitacaoModel("CHAVE_PERDIDA", "Perdeu a chave (sem chave reserva)"),
	new MotivoSolicitacaoModel("PANE_SECA", "Pane Seca"),
	new MotivoSolicitacaoModel("PANE_ELETRICA", "Pane Elétrica"),
	new MotivoSolicitacaoModel("PANE_MECANICA", "Pane Mecânica"),
	new MotivoSolicitacaoModel("FUNDIU_MOTOR", "Fundiu o motor"),
	new MotivoSolicitacaoModel("COLISAO", "Colisão"),
	new MotivoSolicitacaoModel("CAPOTADO", "Capotado")
]